import { createSelector } from '@reduxjs/toolkit';
import { selectExcludeWords } from 'shared/selectors/jsonQuery';

export const selectExcludeWordsFilter = createSelector(selectExcludeWords, value => ({
  label: 'Исключить слова в объявлении',
  value,
  placeholder: 'Например: переуступка',
}));
